import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  CreateSessionParams,
  CreateSessionResponse,
  createSession,
} from '@utils/backend-api/sessions';

export default function useCreateSession() {
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: CreateSessionParams) => createSession(params),
    {
      onSuccess: (response: CreateSessionResponse) => {
        if (response.returningUrl) {
          toast.success("You've been logged in");
          window.location.href = response.returningUrl;
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
